import React, { useState } from "react";
// import { Link } from 'react-router-dom';
// import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Mainbanner from "./Mainbanner/Mainbanner";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title> التنظيم للسفر والسياحة | أفضل الرحلات والعروض السياحية</title>
        <link rel="canonical" href="https://tnzeem-sa.com/" />
        <meta
          name="description"
          content="اكتشف العروض السياحية مع التنظيم للسفر والسياحة. نوفر رحلات فردية وجماعية ، عروض شهر العسل، وبرامج  بأسعار تنافسية تشمل الإقامة والجولات."
        />
        <meta
          name="keywords"
          content="عروض سياحية, رحلات, برامج VIP, حجز سفر, إقامة, مواصلات, شركة سياحة"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "التنظيم للسفر والسياحة",
            url: "https://tnzeem-sa.com",
            logo: "https://tnzeem-sa.com/logo.png",
            sameAs: [
              "https://www.facebook.com/tnzeemksa/",
              "https://www.instagram.com/tnzeem_ksa/",
              "https://www.youtube.com/@tnzeem_ksa",
              "https://www.tiktok.com/@tnzeem_ksa",
              "https://www.snapchat.com/@tnzeem_ksa"
            ],
          })}
        </script>
  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "الرئيسية",
        "item": "https://tnzeem-sa.com/"
      }
    ]
  })}
</script>
      </Helmet>
      <Mainbanner />
    </>
  );
};

export default Home;
